<div class="flex flex-column gap-2 p-3 border-bottom-1 surface-border">
  <div class="flex align-items-center gap-1">
    <p-iconfield iconPosition="left" class="flex-1 min-w-0">
      <p-inputicon [styleClass]="esperandoBusqueda() ? 'pi pi-spinner pi-spin' : 'pi pi-search'" />
      <input
        pInputText
        type="text"
        class="w-full p-inputtext-sm"
        placeholder="Buscar chat"
        [ngModel]="busqueda()"
        (ngModelChange)="onBusqueda($event)"
        [attr.aria-busy]="esperandoBusqueda()"
        autocomplete="off"
        aria-label="Buscar chat"
      />
    </p-iconfield>

    @if (mostrarAcciones() && conversaciones().length > 0) {
      <p-button
        type="button"
        icon="pi pi-ellipsis-v"
        styleClass="p-button-text p-button-sm"
        ariaLabel="Acciones de la lista"
        (onClick)="listaMenu.toggle($event)"
      />
      <p-menu #listaMenu [model]="menuItems" [popup]="true" appendTo="body" />
    }
  </div>

  <p-selectButton
    [options]="filtros"
    optionLabel="label"
    optionValue="value"
    size="small"
    [allowEmpty]="false"
    [ngModel]="filtro()"
    (ngModelChange)="filtro.set($event)"
  />
</div>

<div class="chat-list__items flex-1 overflow-y-auto">
  @if (loading()) {
    <div class="flex flex-column gap-3 p-3">
      @for (skeleton of skeletons; track skeleton) {
        <div class="flex align-items-center gap-2">
          <p-skeleton shape="circle" size="2.5rem" />
          <div class="flex-1">
            <p-skeleton width="70%" height="0.75rem" styleClass="mb-2" />
            <p-skeleton width="45%" height="0.65rem" />
          </div>
        </div>
      }
    </div>
  } @else if (visibles().length === 0) {
    <div class="p-4 text-center text-color-secondary">
      <i class="pi pi-inbox text-2xl" aria-hidden="true"></i>
      <p class="m-0 mt-2 text-sm">{{ vacio() }}</p>
    </div>
  } @else {
    @for (conversacion of visibles(); track conversacion.personaId) {
      <app-chat-list-item
        [conversacion]="conversacion"
        [activo]="conversacion.personaId === seleccionadaId()"
        [perspectiva]="perspectiva()"
        [mostrarNivel]="mostrarNivel()"
        [mostrarAvisoDatos]="mostrarAvisoDatos()"
        [cantCulto]="cantCulto()"
        (seleccionar)="seleccionar.emit(conversacion.personaId)"
      />
    }
  }
</div>

<ng-content select="[chatListaExtra]" />
